export default {
    // History列表
    approvalHistoryShow: "/approvalHistory/show",
};
